import { useFormik } from 'formik';
// mantine
import { Button, Switch, UnstyledButton } from '@mantine/core';
// components
import { TPersona } from '@newo/api/gateway';
import PersonasAutocomplete from '@/modules/Personas/components/PersonasAutocomplete';
// utils
import useAKBStore from '@/pages/AKB/AKB.store.ts';

import validationSchema from '@/pages/AKB/components/PersonaSelect/components/SelectPersonaForm/SelectPersonaForm.schema.ts';

interface SelectPersonFormProps {
    onClose: () => void;
    onSubmit: (persona: TPersona) => void;
}

const initialValues: { persona?: TPersona } = {
    persona: undefined
};

const SelectPersonaForm = ({ onClose, onSubmit }: SelectPersonFormProps) => {
    const withAgentFlag = useAKBStore((state) => state.withAgentFlag);
    const toggleWithAgentFlag = useAKBStore(
        (state) => state.toggleWithAgentFlag
    );
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit(values) {
            if (values.persona) {
                onSubmit(values.persona);
                onClose();
            }
        }
    });

    const handleCancel = () => {
        onClose();
    };

    const handlePersonaSelect = (persona?: TPersona) => {
        formik.setFieldValue('persona', persona);
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            <Switch
                checked={withAgentFlag}
                label="Show Personas linked to Agent"
                onChange={() => {
                    toggleWithAgentFlag();
                }}
            />
            <PersonasAutocomplete
                label="Select Persona"
                params={{
                    is_linked_to_agent: withAgentFlag ? true : undefined
                }}
                placeholder="Start typing..."
                onSelect={handlePersonaSelect}
            />

            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={handleCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={
                        !formik.dirty || !formik.isValid || formik.isSubmitting
                    }
                    size="xs"
                    type="submit"
                >
                    Save
                </Button>
            </div>
        </form>
    );
};

export default SelectPersonaForm;
